<template>
    <div class="suggestion">
        <div class="rules-suggestion">
            <span class="rule" :style="{'color': colors.theme == 'dark' ? '#697582' : '#697582'}">{{$t("components.EnigmaToggle.EnigmaSugestion.rule")}}</span>
            <!-- <span class="rule">* Você pode fazer quantas sugestões quiser gratuitamente</span> -->
            <!-- <span class="rule">* O enigma começa valendo 20.000 pontos</span> -->
        </div>        
        <input  @submit.prevent="sendEnigma()"
                @keyup.enter="sendEnigma()"
                :style="{color: colors.secondary}"
                type="number" 
                class="suggestion-input"
                :class="`suggestion-input-${enigma.letter}`"
                :placeholder='$t("components.EnigmaToggle.EnigmaSugestion.placeholder")'
                id="suggestionInput"
                ref="suggestionInput">
        <div class="suggestion-send">
            <div class="button-send" @click="sendEnigma()" @touch="sendEnigma()">
                <button-default buttonType="send-sugestion" name="suggestion" classButton="game" :textButton='$t("components.EnigmaToggle.EnigmaSugestion.textButton[0]")' :loaderButton="loaderButton"></button-default>
            </div>
            <div class="button-send" @click="openEnigma()">
                <button-default buttonType="back-to-enigmas" textButton="Voltar"></button-default>
            </div>
        </div>
    </div>
</template>
<script>
import ButtonDefault from '../../Buttons/ButtonDefault'
import decodeApi from '../../../api/decode.js'
export default {
    data(){
        return{
            loaderButton : false,
            colors:{}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },    
    components : {
        ButtonDefault
    },
    props: {
        enigma : {
            type : Object,
            required : true
        }
    },
    mounted() {

    },
    methods: {
        async sendEnigma(){
            if(this.loaderButton == true){
                return
            }
            this.loaderButton = true
            const { teamGameId, userId } = this.$store.getters.getSimple(['teamGameId', 'userId'])
            const attempt = this.$refs.suggestionInput.value
            const enigmaOrder = this.enigma.letter
            if(attempt == ''){
                this.$toaster.warning(this.$t("components.EnigmaToggle.EnigmaSugestion.toasterTexts[0]"))
                this.loaderButton = false
                return
            }
            try {
                const response = await decodeApi.patch(`/team-games/${teamGameId}/attempt`, {
                    attempt : parseInt(attempt),
                    enigmaOrder,
                    userId
                })
                this.input = false
                this.$toaster.success(this.$t("components.EnigmaToggle.EnigmaSugestion.toasterTexts[1]"))
                this.loaderButton = false
            } catch (error) {
                // console.log(error.response)
                this.$toaster.warning(this.$t("components.EnigmaToggle.EnigmaSugestion.toasterTexts[2]"))
                this.$refs.suggestionInput.value = ''
                this.loaderButton = false
            }
            document.querySelector(`.suggestion-input-${enigmaOrder}`).value = ''
            
        },
        openEnigma(){
            this.$emit('openEnigma', true)
        }
    }
}
</script>
<style lang="scss" scoped>
    .suggestion{

        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .rules-suggestion{

            // margin-bottom: 10%;
            display: flex;
            flex-direction: column;
            letter-spacing: 1px;
            text-transform: uppercase;
            font-weight: bold;
            font-size: 14px;
            color: black;
            width: 80%;
            text-align: center;
        }

        .suggestion-input{

            margin: 10%;
            width: 90%;
            padding: 5%;
            text-align: center;
            outline: none;
            border-radius: 50px;
            border-bottom: none;
            border: 1px solid rgba(141, 141, 141, 0.192);
            font-size: 32px;
            font-weight: 900;

            &::placeholder{
                font-size: 16px;
                font-weight: 400;
            }
        }

        .suggestion-send{

            width: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;

            .button-send{
                padding: 12px 0;
                width: 48%;
            }
        }
    }

    @media only screen and (min-width: 750px){
        .suggestion{
            .suggestion-input{
                padding: 2%;
            }
        }    
    }
</style>
